import { useGSAP } from '@gsap/react';
import {
	Breakpoints,
	Container,
	DecorativeImage,
	Layout,
	LayoutProps,
	ThemeProvider,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import gsap from 'gsap';
import * as React from 'react';
import styled from 'styled-components';
import { ResponsiveText } from '../components/responsive-text';

const gridDisplay = {
	[Breakpoints.default]: [
		{ name: '.', columns: 2 },
		{ name: 'intro-vector', columns: 20 },
		{ name: '.', columns: 2 },
		{ name: '.', columns: 0 }, // gap
		{ name: '.', columns: 2 },
		{ name: 'intro-text', columns: 20 },
		{ name: '.', columns: 2 },
	],
	[Breakpoints.b960]: [
		{ name: '.', columns: 2 },
		{ name: 'intro-text', columns: 11 },
		{ name: '.', columns: 2 }, // gap
		{ name: 'intro-vector', columns: 7 },
		{ name: '.', columns: 2 },
	],
	[Breakpoints.b1920]: [
		{ name: '.', columns: 3 },
		{ name: 'intro-text', columns: 9 },
		{ name: '.', columns: 2 }, // gap
		{ name: 'intro-vector', columns: 7 },
		{ name: '.', columns: 3 },
	],
};

const IntroSectionLayout = styled(Layout)<LayoutProps>`
	padding: var(--size-dynamic0140) 0;
	background-color: var(--c-blue600);
	& > div {
		display: flex;
		align-items: center;

		:first-child {
			margin-bottom: 60px;
		}

		@media screen and (min-width: 960px) {
			padding: var(--size-dynamic0250) 0;

			:first-child {
				margin-bottom: 0px;
			}
		}
	}
`;

const TresMastersPalabras = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	aspect-ratio: 1 / 1;
	width: 100%;
	max-width: 200px;
	margin: 0 auto;
	& > img {
		position: absolute;
		& :first-child {
			width: 90%;
		}
	}

	@media screen and (min-width: 560px) {
		max-width: 350px;
	}

	@media screen and (min-width: 960px) {
		max-width: 600px;
		margin: 0;
		margin-left: auto;
	}
`;

export const Intro = (): React.ReactElement => {
	const tresPalabrasWrapperRef = React.useRef<HTMLImageElement>(null);
	const tresPalabrasRef = React.useRef<HTMLImageElement>(null);

	useGSAP(() => {
		if (!tresPalabrasRef.current || !tresPalabrasWrapperRef.current) return;

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: tresPalabrasWrapperRef.current,
				start: 'top 80%',
				toggleActions: 'play none none none',
				once: true,
			},
		});

		tl.fromTo(
			tresPalabrasRef.current,
			{ rotation: 0 },
			{
				rotation: 1080,
				duration: 3,
				ease: 'power3.out',
			},
			0,
		);
	}, []);

	return (
		<ThemeProvider theme={'inverted'}>
			<IntroSectionLayout data-testid="intro-section" appearance={gridDisplay}>
				<TresMastersPalabras ref={tresPalabrasWrapperRef}>
					<DecorativeImage src="https://assets.volkswagen.com/is/image/volkswagenag/intro_vector_3%201?Zml0PWNyb3AlMkMxJndpZD0xMzM1JmhlaT0xMzM1JmZtdD1wbmctYWxwaGEmYmZjPW9mZiZhYmMw" />
					<DecorativeImage
						ref={tresPalabrasRef}
						src="https://assets.volkswagen.com/is/image/volkswagenag/intro_vector_words_2%201?Zml0PWNyb3AlMkMxJndpZD0xMzM1JmhlaT0xMzM1JmZtdD1wbmctYWxwaGEmYmZjPW9mZiZhYmMw"
					/>
				</TresMastersPalabras>
				<Container data-testid="intro-text-container" wrap={'always'}>
					<ResponsiveText
						bold
						appearance={{
							[Breakpoints.default]: TokenTextAppearance.headline400,
							[Breakpoints.b960]: TokenTextAppearance.headline500,
						}}
					>
						Máster de la carretera
					</ResponsiveText>
					<ResponsiveText
						appearance={{
							[Breakpoints.default]: TokenTextAppearance.copy200,
							[Breakpoints.b1920]: TokenTextAppearance.bigcopy100,
						}}
					>
						{' '}
						<p>
							Hemos reunido todo nuestro conocimiento sobre conducción en un máster único, creado para dominar la
							carretera en distintos terrenos: asfalto, hielo y nieve.
						</p>
						<p>
							<b>
								Este máster exclusivo de Volkswagen incluye tres experiencias diferentes, repartidas en tres fines de
								semana y de la mano de nuestros pilotos profesionales. Todo un reto para los amantes de la adrenalina.
							</b>
						</p>
						<p>
							<b>¡Muy pronto anunciaremos a las personas seleccionadas! Mantente atento.</b>
						</p>
					</ResponsiveText>
					{/* <div style={{ paddingTop: '20px' }}></div>
					<CTA tag="button" onClick={onApuntateClick} aria-label="aria label for CTA" type="button">
						Apúntate
					</CTA> */}
				</Container>
			</IntroSectionLayout>
		</ThemeProvider>
	);
};
